import { treezBlackAndWhiteColors, treezGreen, treezGrey, treezTextColors, } from "./treez-color-constants";
import { lightPalette } from "./treez-palettes";
export const lightGreenColors = {
    green01: { main: treezGreen[1] },
    green02: { main: treezGreen[2] },
    green03: { main: treezGreen[3] },
    midribGreen: { main: treezGreen[4] },
    sativaGreen: { main: treezGreen[5] },
};
export const darkGreenColors = {
    green06: { main: treezGreen[6] },
    brandGreen: { main: treezGreen[7] },
    green08: { main: treezGreen[8] },
    green09: { main: treezGreen[9] },
    green10: { main: treezGreen[10] },
};
export const lightGreyColors = {
    grey01: { main: treezGrey[1] },
    grey02: { main: treezGrey[2] },
    grey03: { main: treezGrey[3] },
    grey04: { main: treezGrey[4] },
    grey05: { main: treezGrey[5] },
};
export const darkGreyColors = {
    grey06: { main: treezGrey[6] },
    grey07: { main: treezGrey[7] },
    grey08: { main: treezGrey[8] },
    grey09: { main: treezGrey[9] },
    grey10: { main: treezGrey[10] },
};
export const blackAndWhiteColors = {
    primaryWhite: { main: treezBlackAndWhiteColors.primaryWhite },
    primaryBlack: { main: treezBlackAndWhiteColors.primaryBlack },
};
export const textColors = {
    disabledText: { main: treezTextColors.disabled },
    tertiaryText: { main: treezTextColors.tertiary },
    secondaryText: { main: treezTextColors.secondary },
    primaryBlackText: { main: treezTextColors.primary },
    primaryWhiteText: { main: treezTextColors.primaryWhite },
};
export const allColors = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, lightGreenColors), darkGreenColors), lightGreyColors), darkGreyColors), blackAndWhiteColors), textColors), lightPalette), { treezGreen,
    treezGrey });
